import { toCoverType } from 'scenes/common/api/quote/marshaller/coverage';
import {
  findPremium,
  toPremium,
} from 'scenes/common/api/quote/marshaller/premium';
import {
  WireCoverageOptionalExtraId,
  WireCoverType,
  WireItemType,
  WirePremium,
} from 'scenes/common/api/quote/types';
import { InsuranceOption } from 'scenes/home/types';

import { WireHomeCoverageResponse, WireHomeQuotePayload } from '../types';

export const toInsuranceOption = (
  coverage: WireHomeCoverageResponse,
  quote: WireHomeQuotePayload
): InsuranceOption => ({
  coverType: toCoverType(coverage.name),
  premium: toPremium(findPremium(quote.premiums, coverage.premiumRefIds)),
});

export const unmarshalPremiums = (quote: WireHomeQuotePayload) =>
  quote.coverages
    .filter(({ name }) => Object.values(WireCoverType).includes(name))
    .map((coverage) => toInsuranceOption(coverage, quote));

export const findSelectedExtras = (
  premiums: WirePremium[],
  coverageId: string
) =>
  premiums.filter(
    (premium) =>
      premium.id.toLowerCase().includes(`${coverageId.toLowerCase()}-`) &&
      Object.values(WireCoverageOptionalExtraId).some((extraId) =>
        premium.id.includes(extraId)
      ) &&
      !premium.inclusion &&
      premium.selected
  );

const hasPortables = (
  premiums: WirePremium[],
  coverageId: string,
  itemType: WireItemType
) =>
  premiums.some(
    (premium) =>
      premium.id.toLowerCase().includes(`${coverageId.toLowerCase()}-`) &&
      premium.id.includes(itemType) &&
      !premium.inclusion &&
      premium.selected
  );

export const hasGeneralPortables = (
  premiums: WirePremium[],
  coverageId: string
) => hasPortables(premiums, coverageId, WireItemType.GeneralPortables);

export const hasSpecifiedPortables = (
  premiums: WirePremium[],
  coverageId: string
) => hasPortables(premiums, coverageId, WireItemType.SpecifiedPortables);
